import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import * as objectConstants from '../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class IconButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.show = this.show.bind(this);
        this.setAlignment = this.setAlignment.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {

    }

    show(){
        let optionRef = this.refs[this.props.id];
        TweenLite.set(optionRef, {height:"auto"});
        TweenLite.from(optionRef, objectConstants.BUTTON_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onComplete);
    }

    onComplete(){

    }

    setAlignment(){
        if(typeof this.props.alignment !== "undefined"){
            return this.props.alignment;
        }else{
            return "text-center";
        }
    }

    render() {

        return (
            <div className={`object-container ${this.setAlignment()}`} ref={this.props.id}>
                <button className={`btn btn-lg guroo-btn ${this.props.class}`} disabled={this.props.isDisabled} onClick={this.props.onClick}>{this.props.label}</button>
            </div>
        );
    }
}

IconButton.propTypes = {
    label: PropTypes.string,
    class: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    id:PropTypes.string.isRequired,
    alignment: PropTypes.string,
    isDisabled: PropTypes.bool,
};

IconButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(IconButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/IconButton.js
 **/